import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    value: false
};

export const progressReducer = createSlice({
  name: 'progress',
  initialState,
  // El campo `reducers` nos permite definir reductores y generar acciones asociadas.
  reducers: {    
    showProgress: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { showProgress } = progressReducer.actions;
export const selectProgress = (state) => state.progress.value;
export default progressReducer.reducer;